import React from 'react';
import { Box } from '@mui/material';
import WidgetPreview from './WidgetPreview';
import { ZmanimWidget } from '../../business/ZmanimWidget/ZmanimWidget';
import { WeatherWidget } from '../../business/WeatherWidget/WeatherWidget';
import { ShabbatWidget } from '../../business/ShabbatWidget/ShabbatWidget';
import { TextWidget } from '../../business/TextWidget/TextWidget';
import { NoticeBoardWidget } from '../../business/NoticeBoardWidget/NoticeBoardWidget';
import { EmergencyWidget } from '../../business/EmergencyWidget/EmergencyWidget';
import { ContactsWidget } from '../../business/ContactsWidget/ContactsWidget';
import { SimchaWidget } from '../../business/SimchaWidget/SimchaWidget';
import { NitzavSpotlightWidget } from '../../business/NitzavSpotlightWidget/NitzavSpotlightWidget';
import { ExpensesAnalyticsWidget } from '../../business/ExpensesAnalyticsWidget/ExpensesAnalyticsWidget';
import { FinancialGaugeWidget } from '../../business/FinancialGaugeWidget/FinancialGaugeWidget';
import { ImageWidget } from '../../business/ImageWidget/ImageWidget';
import { MoadWidget } from '../../business/MoadWidget/MoadWidget';
import { TefilotWidget } from '../../business/TefilotWidget/TefilotWidget';
import { ParnasWidget } from '../../business/ParnasWidget/ParnasWidget';
import { ClockWidget } from '../../business/ClockWidget/ClockWidget';
import { OmerWidget } from '../../business/OmerWidget/OmerWidget';
import { NextMinyaWidget } from '../../business/NextMinyaWidget/NextMinyaWidget';
import { HalachicTimesWidget } from '../../business/HalachicTimesWidget/HalachicTimesWidget';
import { InyaneiHaYomWidget } from '../../business/InyaneiHaYomWidget/InyaneiHaYomWidget';
import { LimudimWidget } from '../../business/LimudimWidget/LimudimWidget';
import { SeatingMapWidget } from '../../business/SeatingMapWidget/SeatingMapWidget';
import AutoScaler from '../../business/AutoScaler/AutoScaler';
import {
    dummyZmanimData,
    dummyWeatherData,
    dummyShabbatData,
    dummyTextData,
    dummyNoticeBoardData,
    dummyEmergencyData,
    dummyContactsData,
    dummySimchaData,
    dummyNitzavData,
    dummyExpensesData,
    dummyFinancialGaugeData,
    dummyImageData,
    dummyMoadData,
    dummyTefilotData,
    dummyParnasData,
    dummyOmerData,
    dummyInyaneiData,
    dummyLimudimData,
    dummySeatingMapData,
    dummyNextMinyaData
} from './dummyData';

/**
 * קומפוננטה להצגת תצוגה מקדימה של טמפלייט ווידג'ט
 * מקבלת את סוג הווידג'ט ושם הטמפלייט ומציגה תצוגה מקדימה עם נתוני דמה
 */
const TemplatePreview = ({ componentKey, templateName, scale = 0.2 }) => {
    const renderWidget = () => {
        switch (componentKey) {
            case 'ZmanimWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <ZmanimWidget
                                {...dummyZmanimData}
                                template={templateName}
                                title="סדר היום"
                                showTitle={true}
                                location={{ lat: 32.0853, lng: 34.7818 }}
                                dispatch={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'WeatherWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <WeatherWidget
                                {...dummyWeatherData}
                                template={templateName}
                                location={{ lat: 32.0853, lng: 34.7818 }}
                                cityName="תל אביב"
                                title="מזג אוויר"
                                showTitle={false}
                                dispatch={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'ShabbatWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <ShabbatWidget
                                {...dummyShabbatData}
                                template={templateName}
                                title="זמני שבת"
                                showTitle={true}
                                location={{ lat: 32.0853, lng: 34.7818 }}
                                dispatch={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'TextWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <TextWidget
                                {...dummyTextData}
                                template={templateName}
                                title="טקסט"
                                showTitle={false}
                                onSave={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'NoticeBoardWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <NoticeBoardWidget
                                {...dummyNoticeBoardData}
                                template={templateName}
                                title="לוח מודעות"
                                showTitle={true}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'EmergencyWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <EmergencyWidget
                                initialData={dummyEmergencyData.data}
                                template={templateName}
                                title="חירום והצלה"
                                showTitle={true}
                                onSave={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'ContactsWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <ContactsWidget
                                initialData={dummyContactsData.data}
                                template={templateName}
                                title="אנשי קשר"
                                showTitle={true}
                                onSave={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'SimchaWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <SimchaWidget
                                initialData={dummySimchaData.data}
                                template={templateName}
                                title="שמחות"
                                showTitle={true}
                                onSave={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'NitzavSpotlightWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <NitzavSpotlightWidget
                                data={dummyNitzavData.data}
                                title="נציב הקהילה"
                                showTitle={false}
                                onSave={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'ExpensesAnalyticsWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <ExpensesAnalyticsWidget
                                data={dummyExpensesData.data}
                                freeText={dummyExpensesData.freeText}
                                template={templateName}
                                title="הוצאות"
                                showTitle={true}
                                onSave={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'FinancialGaugeWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <FinancialGaugeWidget
                                data={dummyFinancialGaugeData.data}
                                template={templateName}
                                title="תמונת מצב כספית"
                                showTitle={true}
                                onSave={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'ImageWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <ImageWidget
                                imageUrl={dummyImageData.imageUrl}
                                template={templateName}
                                title="תמונה"
                                showTitle={false}
                                onSave={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'MoadWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <MoadWidget
                                moadData={dummyMoadData.moadData}
                                customTimes={dummyMoadData.customTimes}
                                loading={false}
                                error={null}
                                days={[]}
                                template={templateName}
                                title="פסח"
                                showTitle={true}
                                widgetId="preview"
                                location={{ lat: 32.0853, lng: 34.7818 }}
                                dispatch={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'TefilotWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <TefilotWidget
                                tefilotData={dummyTefilotData.tefilotData}
                                customTimes={dummyTefilotData.customTimes}
                                loading={false}
                                error={null}
                                recurringDisplay="compact"
                                template={templateName}
                                title="תפילות יום חול"
                                showTitle={true}
                                widgetId="preview"
                                location={{ lat: 32.0853, lng: 34.7818 }}
                                dispatch={() => { }}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'ParnasWidget': {
                const _today      = new Date().toISOString().split('T')[0];
                const _d          = new Date();
                const _daysToSat  = (6 - _d.getDay() + 7) % 7 || 7;
                _d.setDate(_d.getDate() + _daysToSat);
                const _nextShabbat = _d.toISOString().split('T')[0];
                const parnasContent = (
                    <ParnasWidget
                        parnasData={{
                            activeSponsors: [
                                { sponsorName: 'משפחת כהן',       slotType: 'daily',   note: 'לעילוי נשמת אבינו מורינו' },
                                { sponsorName: 'משפחת לוי',       slotType: 'weekly',  note: '' },
                                { sponsorName: "ר' ישראל ישראלי", slotType: 'monthly', note: 'לרפואת שלמה' },
                            ],
                            currentParshaName:        'ויקרא',
                            currentParshaShabbatDate: _nextShabbat,
                            todayHebrewLabel:         "כ\"ט באדר תשפ\"ו",
                            effectiveDateISO:         _today,
                            todayHYear:               5786,
                        }}
                        sponsors={dummyParnasData.sponsors}
                        parnasType={dummyParnasData.parnasType}
                        parnasTypeCustomLabel={dummyParnasData.parnasTypeCustomLabel}
                        parnasTypeIcon={dummyParnasData.parnasTypeIcon}
                        template={templateName}
                        title="פרנס הקהילה"
                        showTitle={true}
                        dispatch={() => {}}
                    />
                );
                return templateName === 'WeeklyYear' ? (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white', position: 'relative' }}>
                        <div style={{ position: 'absolute', inset: 0 }}>{parnasContent}</div>
                    </Box>
                ) : (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>{parnasContent}</AutoScaler>
                    </Box>
                );
            }

            case 'ClockWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <ClockWidget template={templateName} />
                        </AutoScaler>
                    </Box>
                );

            case 'InyaneiHaYomWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <InyaneiHaYomWidget
                                previewItems={dummyInyaneiData.items}
                                previewHebrewDate={dummyInyaneiData.hebrewDate}
                                template={templateName}
                                title="ענייני היום"
                                showTitle={true}
                                location={null}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'LimudimWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <LimudimWidget
                                previewItems={dummyLimudimData.items}
                                previewHebrewDate={dummyLimudimData.hebrewDate}
                                template={templateName}
                                title="לימודים יומיים"
                                showTitle={true}
                                location={null}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'OmerWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <OmerWidget
                                widgetId="preview"
                                previewOmerDay={dummyOmerData.omerDay}
                                loading={false}
                                error={null}
                                dispatch={() => {}}
                                location={null}
                                nusach={dummyOmerData.nusach}
                                showBracha={dummyOmerData.showBracha}
                                showFullNusach={dummyOmerData.showFullNusach}
                                showLeshemYichud={dummyOmerData.showLeshemYichud}
                                showPasuk={dummyOmerData.showPasuk}
                                showAfterCount={dummyOmerData.showAfterCount}
                                template={templateName}
                                title="ספירת העומר"
                                showTitle={true}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'HalachicTimesWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <HalachicTimesWidget
                                zmanim={{
                                    alotHaShachar: '05:15', sunrise: '06:30',
                                    sofZmanShmaMGA: '08:45', sofZmanShma: '09:15',
                                    sofZmanTfillaMGA: '09:45', sofZmanTfilla: '10:15',
                                    chatzot: '12:30', minchaGedola: '13:00',
                                    minchaKetana: '16:15', plagHaMincha: '17:30',
                                    sunset: '18:45', tzeit85deg: '19:20',
                                    chatzotNight: '00:30',
                                }}
                                hebrewDate={{ hebrewShort: "\u05D4\u05F3 \u05D1\u05E9\u05D1\u05D8", hd: 5, hm: 11 }}
                                template={templateName}
                                title={"\u05D6\u05DE\u05E0\u05D9 \u05D4\u05D9\u05D5\u05DD \u05D4\u05D4\u05DC\u05DB\u05EA\u05D9\u05D9\u05DD"}
                                showTitle={true}
                                dispatch={() => {}}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'SeatingMapWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <SeatingMapWidget
                                mapData={dummySeatingMapData.mapData}
                                template={templateName}
                                title="מפת מושבים"
                                showTitle={true}
                            />
                        </AutoScaler>
                    </Box>
                );

            case 'NextMinyaWidget':
                return (
                    <Box sx={{ width: '100%', height: '100%', bgcolor: 'white' }}>
                        <AutoScaler>
                            <NextMinyaWidget
                                widgetId="preview"
                                template={templateName}
                                title="מניין הבא"
                                showTitle={true}
                                previewPrayers={dummyNextMinyaData.prayers}
                                previewNow={dummyNextMinyaData.previewNow}
                            />
                        </AutoScaler>
                    </Box>
                );

            default:
                return (
                    <Box sx={{ p: 2, textAlign: 'center', color: '#64748b', bgcolor: 'white' }}>
                        תצוגה מקדימה לא זמינה
                    </Box>
                );
        }
    };

    return (
        <WidgetPreview scale={scale}>
            {renderWidget()}
        </WidgetPreview>
    );
};

export default TemplatePreview;
